import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/search';

const initialState = fromJS({
  config: { data: [], state: null },
  arbitrationConfig: { data: [], state: null },
  codes: {
    caseStatus: [],
    data: {},
    state: null,
    juryType: [],
    appraiserType: [],
    discoveryStatus: [],
    motionStatus: [],
    offerStatus: [],
    trialType: [],
  },
  resultsConfig: { data: [], state: null },
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
    isHistorySearch: false,
  },
  arbitrationResults: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  soahResults: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  arbitrationPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  soahPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  arbitratorResults: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  arbitratorPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  searchLastPayload: { data: {}, state: null },
  soahSearchLastPayload: { data: {}, state: null },
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(['config', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_CODES_SUCCESS: {
      return state
        .setIn(['codes', 'state'], fetchingState.LOADED)
        .setIn(['codes', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_CODEFILE_CASE_STATUS_SUCCESS: {
      return state.setIn(['codes', 'caseStatus'], fromJS(action.data.results));
    }
    case actions.FETCH_CODEFILE_JURY_TYPE_SUCCESS: {
      return state.setIn(['codes', 'juryType'], fromJS(action.data.results));
    }
    case actions.FETCH_CODEFILE_TRIAL_TYPE_SUCCESS: {
      return state.setIn(['codes', 'trialType'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_CODEFILE_APPRAISER_TYPE_SUCCESS: {
      return state.setIn(
        ['codes', 'appraiserType'],
        fromJS(action.data.results),
      );
    }
    case actions.FETCH_CODEFILE_MOTION_STATUS_SUCCESS: {
      return state.setIn(
        ['codes', 'motionStatus'],
        fromJS(action.data.results),
      );
    }
    case actions.FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS: {
      return state.setIn(
        ['codes', 'discoveryStatus'],
        fromJS(action.data.results),
      );
    }
    case actions.FETCH_CODEFILE_OFFER_STATUS_SUCCESS: {
      return state.setIn(['codes', 'offerStatus'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case actions.SEARCH_SUCCESS: {
      let resultsName = 'results';
      let paginationName = 'pagination';
      let lastPayloadName = 'searchLastPayload';
      if (
        action.payload &&
        action.payload.caseType &&
        action.payload.caseType.value === 'soah'
      ) {
        resultsName = 'soahResults';
        paginationName = 'soahPagination';
        lastPayloadName = 'soahSearchLastPayload';
      }
      if (
        action.payload &&
        action.payload.caseType &&
        action.payload.caseType.value === 'arbitration'
      ) {
        resultsName = 'arbitrationResults';
        paginationName = 'arbitrationPagination';
        lastPayloadName = 'arbitrationSearchLastPayload';
      }
      return state
        .setIn([resultsName, 'state'], fetchingState.LOADED)
        .setIn([resultsName, 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          [lastPayloadName, 'data'],
          fromJS(_.get(action, 'payload', {})),
        )
        .setIn(
          [paginationName, 'count'],
          _.get(action, 'data.totalLitigation', 0),
        );
    }
    case actions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_CODES_START: {
      return state.setIn(['codes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_START: {
      let resultsName = 'results';
      let paginationName = 'pagination';
      if (
        action.payload &&
        action.payload.caseType &&
        action.payload.caseType.value === 'soah'
      ) {
        resultsName = 'soahResults';
        paginationName = 'soahPagination';
      }
      if (
        action.payload &&
        action.payload.caseType &&
        action.payload.caseType.value === 'arbitration'
      ) {
        resultsName = 'arbitrationResults';
        paginationName = 'arbitrationPagination';
      }
      return state
        .setIn([resultsName, 'state'], fetchingState.FETCHING)
        .setIn([resultsName, 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn([paginationName, 'page'], action.page)
        .setIn([paginationName, 'rowsPerPage'], action.pageSize)
        .setIn([resultsName, 'isHistorySearch'], action.isHistorySearch);
    }
    case actions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CODES_ERROR: {
      return state.setIn(['codes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR)
        .setIn(['results', 'isHistorySearch'], false);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_SORT_MODEL: {
      return state.setIn(['results', 'sortModel'], fromJS(action.payload));
    }
    case actions.CHANGE_FILTER_MODEL: {
      return state.setIn(['results', 'filterModel'], fromJS(action.payload));
    }
    default: {
      return state;
    }
  }
};

export default SearchReducer;
